import React from 'react';

function getUrls() {
  return (typeof window !== 'undefined' && window.JINBAN_URLS) || {};
}

export function StartFreeSplit() {
  const [open, setOpen] = React.useState(false);
  const wrapRef = React.useRef(null);
  const urls = getUrls();

  React.useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const downloadSkill = async (e) => {
    e.preventDefault();
    setOpen(false);
    const apiUrl = urls.skill || '/api/v1/skills/jinban.skill';
    try {
      const res = await fetch(apiUrl, { method: 'GET' });
      if (!res.ok) throw new Error('not ready');
      const blob = await res.blob();
      triggerDownload(blob, 'jinban.skill');
    } catch (_) {
      const fallbackUrl = urls.skillFallback || '/static/landing/assets/jinban-skill/SKILL.md';
      const res = await fetch(fallbackUrl);
      const text = await res.text();
      const blob = new Blob([text], { type: 'text/markdown' });
      triggerDownload(blob, 'jinban-skill.md');
    }
  };

  function triggerDownload(blob, filename) {
    const a = document.createElement('a');
    const u = URL.createObjectURL(blob);
    a.href = u;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(u), 2000);
  }

  return (
    <div className="splitcta" ref={wrapRef}>
      <a className="btn splitcta__main" href={urls.startFree || '#start'}>Start free →</a>
      <button
        type="button"
        className={`btn splitcta__chev ${open ? 'is-open' : ''}`}
        aria-label="More ways to start"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {open && (
        <div className="splitcta__menu" role="menu">
          <div className="splitcta__menu-label">More ways to start</div>
          <a className="splitcta__item" href={urls.startFree || '#start'} onClick={() => setOpen(false)}>
            <div className="splitcta__icon splitcta__icon--gold">⚡</div>
            <div>
              <div className="splitcta__title">Start free in browser</div>
              <div className="splitcta__sub">Hosted EU workspace · 60s setup</div>
            </div>
          </a>
          <a className="splitcta__item" href="#" onClick={downloadSkill}>
            <div className="splitcta__icon splitcta__icon--ink">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2v8m0 0l-3-3m3 3l3-3M3 13h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <div className="splitcta__title">
                Download Claude skill
                <span className="splitcta__pill">.skill</span>
              </div>
              <div className="splitcta__sub">Drop into Claude · drive jinban from chat</div>
            </div>
          </a>
          <a className="splitcta__item" href={urls.docs || '#docs'} onClick={() => setOpen(false)}>
            <div className="splitcta__icon splitcta__icon--ink">{'</>'}</div>
            <div>
              <div className="splitcta__title">Read the API docs</div>
              <div className="splitcta__sub">REST · webhooks · SDKs</div>
            </div>
          </a>
        </div>
      )}
    </div>
  );
}
